<template>
  <!-- Reads the card variables, so it only lands right on a media block anchored to the card top-left corner -->
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100 [background:radial-gradient(12rem_circle_at_var(--spotlight-x,50%)_var(--spotlight-y,50%),theme(colors.brand.600/0.25),transparent_60%)]"
  />
</template>
